import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import React from "react";

import { GROUNDLIGHT_SUPPORT_EMAIL } from "config/constants";
import { useAppSelector } from "hooks/store";
import { Typography } from "new-components/typography/Typography";
import { getUserState } from "store/slices/Auth/authSlice";
import { TierType } from "types/users";

export function TerminationNoticeBar() {

  const { tier: userTier } = useAppSelector(getUserState);

  const isVisible = userTier === TierType.Free || userTier === TierType.Paid_1 || userTier === TierType.Paid_2;

  return isVisible ? (
    <Accordion
      disableGutters
      sx={{
        width: "100%",
        backgroundColor: "#FFA500",
        boxShadow: "none",
        "&.Mui-expanded": {
          margin: 0,
        },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
        aria-controls="panel1-content"
        id="panel1-header"
        sx={{maxWidth: "1280px", width: "100%"}}
      >
        <Typography variant="subtitle" fontWeight="medium" color="white">
          {userTier === TierType.Free 
            ? "We are phasing out our free tier of service. Click to learn more." 
            : "We are phasing out some of our products. Click to learn more."
          }
        </Typography>
      </AccordionSummary>
      <AccordionDetails sx={{maxWidth: "1280px", width: "100%"}}>
        <Typography color="white">
          {userTier === TierType.Free 
            ? "As a result you will no longer have access to your Groundlight service as of August 31st, 2025. You will have access to your account and be able to export data until that date, after which your account will no longer be accessible. We appreciate the opportunity to have served you."
            : `As a result you will no longer have access to your Groundlight service as of August 31st, 2025. You will have access to your account and be able to export data until that date, after which your account will no longer be accessible. Your card will not be charged during the month of August. Please do not hesitate to contact ${GROUNDLIGHT_SUPPORT_EMAIL} if you have any questions or require further assistance during this transition. We value your business and appreciate the opportunity to have served you.`
          }
        </Typography>
      </AccordionDetails>
    </Accordion>
  ) : null;
}
